//请自行添加语言资源
const yzCompany = {
  originNo: '发货仓编号',
  originName: '发货仓名称',
  companyCode: '机构编号',
  companyName: '机构名称',
  createTime: '创建时间',
  creator: '创建者',
  updateTime: '更新时间',
  updater: '更新者',
};
export default yzCompany



// WEBPACK FOOTER //
// ./src/page/mdm/yzCompany/lang/yzCompany.zh.js